var map = {
	"./icon-marker-bar-small.svg": 36386,
	"./icon-marker-bar.svg": 99649,
	"./icon-marker-cafe-small.svg": 89546,
	"./icon-marker-cafe.svg": 74948,
	"./icon-marker-circle.svg": 53281,
	"./icon-marker-gas_station-small.svg": 43428,
	"./icon-marker-gas_station.svg": 9559,
	"./icon-marker-iqos-small.svg": 78661,
	"./icon-marker-iqos.svg": 16459,
	"./icon-marker-store-small.svg": 48425,
	"./icon-marker-store.svg": 99755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62938;